import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="rich-text-editor"
// Loads Trix/Action Text on demand; <trix-editor> upgrades once it is defined.
export default class extends Controller {
  connect() {
    import("../lib/rich_text");
  }
}
